import React from 'react'

type FeedbackIconProps = {
	size?: number
	color?: string
	filled?: boolean
}

export const FeedbackIcon: React.FC<FeedbackIconProps> = ({
	size = 16,
	color = 'currentColor',
	filled = false,
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		{filled ? (
			<path
				d="M14 1H2C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H4V14.5L8.5 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1Z"
				fill={color}
			/>
		) : (
			<>
				<path
					d="M14 1H2C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H4V14.5L8.5 11H14C14.5523 11 15 10.5523 15 10V2C15 1.44772 14.5523 1 14 1Z"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M4 4.5H12"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M4 7H9"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</>
		)}
	</svg>
)
